import { split } from 'lodash';

import { Document } from '@lockton-apps/shared/interfaces';
import { UIDocumentFile } from '@lockton-apps/client-gateway/interfaces';

const documentIconMap = new Map([
  ['xls', { icon: 'document_xlsx_thin', iconColor: 'green' }],
  ['xlsx', { icon: 'document_xlsx_thin', iconColor: 'green' }],
  ['pdf', { icon: 'document_pdf_thin', iconColor: 'red' }],
  ['doc', { icon: 'document_docx_thin', iconColor: 'blue' }],
  ['docx', { icon: 'document_docx_thin', iconColor: 'blue' }],
  ['ppt', { icon: 'document_thin', iconColor: 'pink' }],
  ['pptx', { icon: 'document_thin', iconColor: 'pink' }],
]);

export function uiDocumentFile(document: Document): UIDocumentFile {
  const icon = documentIconMap.get(document.fileType) || {
    icon: 'help',
    iconColor: 'grayDark',
  };

  return {
    ...document,
    uiTags: split(document.tags, ', '),
    ...icon,
  };
}
